import { useState } from "react";
import ProjectModal from './ProjectModal';
import projectList from './projectDB'
import './animation.css'

const Projects = () => {

  
  const [showMore, setShowMore] = useState(false);
  const [showAllProjects, setShowAllProjects] = useState(false);
  const [projectsToShow, setProjectsToShow] = useState(2);

  const handleShowMoreClick = () => {
    setShowAllProjects(!showAllProjects);
    setProjectsToShow(showAllProjects ? 2 : projectList.length);
    setShowMore(!showMore);
  };

  const ProjectItem = ({ project, onProjectClick }) => {
    return (
      <div key={project.id} className="my-2 px-2 w-full overflow-hidden sm:w-1/2 sm:my-0 sm:px-4">
        <div className="text-white cursor-pointer" onClick={() => onProjectClick(project.id)}>
          <div className="flex items-center justify-center">
          <img src={project.image} alt={project.name} className='object-cover object-top h-60 w-96' />
          </div>
          <div className="font-sans-semibold text-white text-1xl mb-5 mt-2 text-center ">
            {project.name}
          </div>
        </div>
      </div>
    );
  };
    
  const [selectedProject, setSelectedProject] = useState(null);
    
  const handleProjectClick = (projectId) => {
    const project = projectList.find((p) => p.id === projectId);
    setSelectedProject(project);
  };

  const filteredProjects = showAllProjects ? projectList : projectList.slice(0, projectsToShow);

  

  return (
    <div className="bg-background flex justify-center items-center pb-10">
      <div className="md:w-3/5 mx-5 fade-in">
        <div className="flex items-center pb-4 ">
          <div className="text-gray-200 text-2xl font-sans-semibold">
            Personal Projects
          </div>
          <div className="border-b border-gray-600 h-0.02 md:h-0.06 ml-4 flex-grow"></div>
        </div>
        <div className="flex flex-wrap -mx-2 overflow-hidden sm:-mx-4">
          {filteredProjects.map((project) => (
            <ProjectItem
              key={project.id}
              project={project}
              onProjectClick={handleProjectClick}
            />
          ))}
        </div>
        {selectedProject && (
          <ProjectModal
            project={selectedProject}
            isOpen={true}
            onClose={() => setSelectedProject(null)}
          />
        )}
        {!showAllProjects && projectList.length > 2 && (
          <div className="flex justify-center my-4">
            <button onClick={handleShowMoreClick} className="text-white border text-xs py-3 px-10 rounded font-sans hover:bg-header hover:text-black hover:-translate-y-1 transition duration-500 ease-in-out">
              Show More
            </button>   
          </div>
        )}
        {showAllProjects && (
          <div className="flex justify-center my-4">
            <button onClick={handleShowMoreClick} className="text-white border text-xs py-3 px-10 rounded font-sans hover:bg-header hover:text-black hover:-translate-y-1 transition duration-500 ease-in-out">
              Hide Projects
            </button>   
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
